import { ViewModel,View, ObservableArray } from "binder"
import moment, { Moment } from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { BankAccountSelectorViewModel } from "../bankAccountManipulation/bankAccountManipulation-viewModel";
import  { DebitCardManipulationView } from "./debitCardManipulation-view"
import { DistrictSelectorViewModel } from "src/EnterpriseAdministration/districtManipulation/districtSelector";

export class DebitCardManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت کارت های بانکی ';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.debitCard = ObservableArray.create<debitCard>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new DebitCardManipulationView();
    }
    public getTypeId(): string {
        return "VM-1F1B2482-3CF9-4677-BB0F-6FA17DC6C77E"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set debitCard(v: ObservableArray<debitCard>) { this._debitCard = v; } public get debitCard(): ObservableArray<debitCard> { return this._debitCard;} private _debitCard: ObservableArray<debitCard>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/FinancialServices/GetAllDebitCard',{
                FilteringInformation:filteringInformation
            });
            let rowNumber = 1;
            this.debitCard.update(...result.DebitCard.map(q=>{
                let r = new debitCard(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.bankId = q.BankId;
                r.bankName = q.BankName;
                r.districtId = q.DistrictId;
                r.districtName = q.DistrictName;
                r.accountId = q.AccountId;
                r.takenByDistrictId = q.TakenByDistrictId;
                r.takenByDistrictName = q.TakenByDistrictName;
                r.accountId = q.AccountId;
                r.accountName = q.AccountName;
                r.cardNumber = q.CardNumber;
                r.createDate = moment.utc(q.CreateDate);
                r.expireTime = q.ExpireTime==null? null : moment.utc(q.ExpireTime);          
                r.removeDate = q.RemoveDate==null? null : moment.utc(q.RemoveDate);          
                r.needConfirmation = q.NeedConfirmation;  
                r.canInvalidate = q.RemoveDate==null;          
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async requestDebitCardCreation(){
        let editor = new debitCardEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
        
    async debitCardUpdater(debitCard:debitCard){
        let editor = new debitCardEditor(this,new UpdateServerUpdater());
        debitCard.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async accept(id:any){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/FinancialServices/InvalidateDebitCard',{
                DebitCardId:id
            });
            await this.messageBoxConfirmSuccess('کارت بانکی غیر فعال شد','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }
}

export class debitCard extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:DebitCardManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set cardNumber(v: string) { this._cardNumber = v; } public get cardNumber(): string { return this._cardNumber;} private _cardNumber: string;
    public set needConfirmation(v: boolean) { this._needConfirmation = v; } public get needConfirmation(): boolean { return this._needConfirmation;} private _needConfirmation: boolean;
    public set createDate(v: moment.Moment) { this._createDate = v; } public get createDate(): moment.Moment { return this._createDate;} private _createDate: moment.Moment;
    public set removeDate(v: moment.Moment) { this._removeDate = v; } public get removeDate(): moment.Moment { return this._removeDate;} private _removeDate: moment.Moment;
    public set expireTime(v: moment.Moment) { this._expireTime = v; } public get expireTime(): moment.Moment { return this._expireTime;} private _expireTime: moment.Moment;
    public set canInvalidate(v: boolean) { this._canInvalidate = v; } public get canInvalidate(): boolean { return this._canInvalidate;} private _canInvalidate: boolean;
    
    public set accountId(v: string) { this._accountId = v; } public get accountId(): string { return this._accountId;} private _accountId: string;
    public set accountName(v: string) { this._accountName = v; } public get accountName(): string { return this._accountName;} private _accountName: string;
    public set takenByDistrictId(v: string) { this._takenByDistrictId = v; } public get takenByDistrictId(): string { return this._takenByDistrictId;} private _takenByDistrictId: string;
    public set takenByDistrictName(v: string) { this._takenByDistrictName = v; } public get takenByDistrictName(): string { return this._takenByDistrictName;} private _takenByDistrictName: string;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set bankName(v: string) { this._bankName = v; } public get bankName(): string { return this._bankName;} private _bankName: string;
    public set bankId(v: string) { this._bankId = v; } public get bankId(): string { return this._bankId;} private _bankId: string;
    
    private _typedParent:DebitCardManipulationViewModel;

    cloneTo(debitCard:debitCard){
        debitCard.id = this.id;
        debitCard.cardNumber = this.cardNumber;
        debitCard.expireTime = this.expireTime;
        debitCard.needConfirmation = this.needConfirmation;
        debitCard.setAccount(this.getAccountId(), this.accountName);
        debitCard.setTakenByDistrict(this.getTakenByDistrictId(), this.takenByDistrictName);
    }

    setAccount(id: string, name: string) {
        this.accountId = id;
        this.accountName = name;
    }
    getAccountId() {
        return this.accountId;
    }  

    setTakenByDistrict(id: string, name: string) {
        this.takenByDistrictId = id;
        this.takenByDistrictName = name;
    }
    getTakenByDistrictId() {
        return this.takenByDistrictId;
    }  

    setDistrict(id: string, name: string) {
        this.districtId = id;
        this.districtName = name;
    }
    getDistrictId() {
        return this.districtId;
    }

    setBank(id: string, name: string) {
        this.bankId = id;
        this.bankName = name;
    }
    getBankId() {
        return this.bankId;
    }
    
    async inactiveDebitCard():Promise<void>{
        if(this.canInvalidate) {
            let result:string; 
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','غیرفعال کردن کارت');
            if(result=='yes'){
                this._typedParent.accept(this.id);
            }
        }
    }
    
    async edit(){
        this._typedParent.debitCardUpdater(this);
    }  
}

interface IServerUpdater{
    execute(debitCard:debitCard):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return ' کارت بانکی با موفقیت ثبت شد.';
    }
    async execute(debitCard: debitCard): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/FinancialServices/CreateDebitCard',{
            AccountId:debitCard.getAccountId(),
            CardNumber:debitCard.cardNumber,
            ExpireTime:debitCard.expireTime,
            NeedConfirmation:debitCard.needConfirmation,
            DistrictId:debitCard.getTakenByDistrictId(),
        });
        if(result.IsSuccessful==false){
            if (result.Faults[0].Parameters.FaultId === "096473E7-67AE-4206-9B61-79B70943684A")
                throw "شماره کارت تکراری است.";
            throw "خطا در انجام عملیات";
        }
    }
}

class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'کارت بانکی با موفقیت به روز رسانی شد.';
    }
    async execute(debitCard: debitCard): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/FinancialServices/UpdateDebitCard',{
            Id:debitCard.id,
            AccountId:debitCard.getAccountId(),
            CardNumber:debitCard.cardNumber,
            ExpireTime:debitCard.expireTime,
            DistrictId:debitCard.getTakenByDistrictId(),
            NeedConfirmation:debitCard.needConfirmation,
        });
        if(result.IsSuccessful==false){
            if (result.Faults[0].Parameters.FaultId === "096473E7-67AE-4206-9B61-79B70943684A")
                throw "شماره کارت تکراری است.";
            throw "خطا در انجام عملیات";
        }
    }
}

export class debitCardEditor extends debitCard implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:DebitCardManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.accountSelector = new BankAccountSelectorViewModel(this);
        this.districtSelector = new DistrictSelectorViewModel(this);
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set accountSelector(v: BankAccountSelectorViewModel) { this._accountSelector = v; } public get accountSelector(): BankAccountSelectorViewModel { return this._accountSelector;} private _accountSelector: BankAccountSelectorViewModel;
    public set districtSelector(v: DistrictSelectorViewModel) { this._districtSelector = v; } public get districtSelector(): DistrictSelectorViewModel { return this._districtSelector;} private _districtSelector: DistrictSelectorViewModel;
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.cardNumber)){
            result.push(' شماره کارت بانکی مشخص نشده است.')
        }
        if(this.cardNumber.length != 16){
            result.push(' شماره کارت بانکی نامعتبر است.')
        }
        if(stringIsNullOrEmpty(this.getAccountId())){
            result.push(' حساب مشخص نشده است.')
        }
        return result;
    }

    setAccount(id: string, name: string) {
        this.accountSelector.selectById(id);
    }

    getAccountId() {
        return this.accountSelector.selectedItem?.id;
    }   

    setTakenByDistrict(id: string, name: string) {
        this.districtSelector.selectById(id);
    }

    getTakenByDistrictId() {
        return this.districtSelector.selectedItem?.id;
    }
    
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت کارت بانکی');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex,'خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }

}
